import React from "react";

const StepIndicator = ({ steps, currentStepId }) => {
    const currentIndex = steps.findIndex((s) => s.id === currentStepId);

    return (
        <div className="hvt-stepper-compact">
            <div className="hvt-stepper-compact-label">
                Step {currentIndex + 1} of {steps.length} &middot; {steps[currentIndex]?.label}
            </div>
            <div className="progress">
                <div className="progress-bar" style={{ width: `${((currentIndex + 1) / steps.length) * 100}%` }} />
            </div>
        </div>
    );
};

export default StepIndicator;
